import React, { useState } from 'react';
import personImg from 'assets/person.png';

const DEFAULT_MODAL_TAGS = [
	{
		id: 1,
		name: 'strategicThinking',
		selected: false,
	},
	{
		id: 2,
		name: 'communication',
		selected: false,
	},
	{
		id: 3,
		name: 'expertise',
		selected: false,
	},
];

const Home = (): JSX.Element => {
	const [showModal, setShowModal] = useState(false);
	const [modalTags, setModalTags] = useState(DEFAULT_MODAL_TAGS);

	const setValue = (id: number, value: boolean) => {
		const tmpData = [...modalTags];
		// @ts-ignore
		tmpData.find((item) => item.id === id).selected = value;
		setModalTags(tmpData);
	};

	const cards = [
		{
			id: 1
		},
		{
			id: 2
		},
		{
			id: 3
		},
		{
			id: 4
		},
		{
			id: 5
		},
	];

	return (
		<div className="home">
			{cards.map(({ id }) => (
				<div className="home-card" key={id}>
					<img src={personImg} alt="person" className="thumbnail"/>
					<h3 className="recipient">John Doe</h3>
					<p className="message"><strong>+5</strong> For his positive attitude and being a cool teammate</p>
					<p className="hash-tags">#strategicThinking #communication #expertise</p>
					<div className="bottom-wrapper">
						<p className="sender">From: <strong>Jane Smith</strong></p>
						<button className="button button-blue">Support</button>
					</div>
				</div>
			))}

			<div className="submit-wrapper">
				<button className="button button-green" onClick={() => setShowModal(true)}>Give points</button>
			</div>

			{showModal && (
				<div className="modal">
					<input type="text" placeholder="Recipient name"/>

					<div className="select">
						<h3 className="select-title">Select points amount:</h3>
						<select name="points" id="points-select">
							<option value="5">5</option>
							<option value="10">10</option>
							<option value="15">15</option>
						</select>
					</div>

					<div className="modal-tags">
						<h3 className="modal-tags-title">Select tags:</h3>

						<div className="modal-tags-wrapper">
							{modalTags.map(({ id, name, selected}) => (
								<button
									key={id} className={`button ${selected ? 'button-blue' : 'button-grey'}`}
									onClick={() => setValue(id, !selected)}
								>
									#{name}
								</button>
							))}
						</div>
					</div>

					<textarea placeholder="Your message"/>

					<div className="modal-submit-wrapper">
						<button className="button button-green" onClick={() => setShowModal(false)}>Submit</button>
					</div>
				</div>
			)}
		</div>
	);
};

export default Home;
